module.exports = __webpack_public_path__ + "img/2012-08-18 10.53.46.2f92be60.jpg";